// extracted by mini-css-extract-plugin
module.exports = {"container":"_2pCeN","textEditor":"_1x4xl","saveButton":"gFnMm"};